module.exports = __webpack_public_path__ + "static/media/task6Planet2.c55dd765.png";